import React from 'react';
import { Box, Typography, Paper, Button } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import './EventsCard.scss';

const EventsCard = ({ event }) => {
    // Extract the event details from the props
    const eventName = event.name;
    const venueName = event.courseName;
    const venueLocation = event.courseLocation;
    const dates = event.dates;
    const format = event.format;
    const venueLogoSrc = event.logo;
    const tournamentHomeUrl = event.tournamentLink;

    return (
        <Box className="golf-event-card">
          <Box className="golf-event-card-container">
            {/* Event Title */}
            <Typography variant="h6" component="h2" className="golf-event-title">
              {eventName}
            </Typography>
            
            {/* Venue Info with Logo */}
            <Box className="golf-event-venue-info">
              <Box className="golf-event-venue-logo">
                {venueLogoSrc && (
                  <img 
                    src={venueLogoSrc} 
                    alt={`${venueName} logo`}
                  />
                )}
              </Box>
              
              <Box className="golf-event-venue-details">
                <Typography variant="h6" component="h3" className="golf-event-venue-name">
                  {venueName}
                </Typography>
                <Typography variant="body1" className="golf-event-venue-location">
                  {venueLocation}
                </Typography>
              </Box>
            </Box>
            
            {/* Event Details */}
            <Box className="golf-event-details">
              <Box className="golf-event-detail-item">
                <Typography variant="subtitle1" component="h4" className="golf-event-detail-label">
                  Dates
                </Typography>
                <Typography variant="body1" className="golf-event-detail-value">
                  {dates}
                </Typography>
              </Box>
              
              <Box className="golf-event-detail-item">
                <Typography variant="subtitle1" component="h4" className="golf-event-detail-label">
                  Format
                </Typography>
                <Typography variant="body1" className="golf-event-detail-value">
                  {format}
                </Typography>
              </Box>
            </Box>
            
            {/* Footer Button */}
            {tournamentHomeUrl && (
              <Box className="golf-event-card-footer">
                <Button 
                    variant="outlined" 
                    endIcon={<ArrowForwardIcon fontSize="small" />}
                    href={tournamentHomeUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="golf-event-button"
                >
                    Tournament Home
                </Button>
              </Box>
            )}
          </Box>
        </Box>
    );
};
    
export default EventsCard;